export default __webpack_public_path__ + "static/media/check.361c5f4d.svg";